export default function LoadingScreen() {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-ocean-dark">
      <div className="text-center">
        <div className="relative w-24 h-24 mx-auto mb-8">
          <div className="absolute inset-0 border-4 border-ocean-light/30 rounded-full"></div>
          <div className="absolute inset-0 border-4 border-transparent border-t-ocean-light rounded-full animate-spin"></div>
        </div>
        <h2 className="text-2xl font-bold text-ocean-sky mb-2">Wave Spark</h2>
        <p className="text-ocean-light">Loading ocean experience...</p>
      </div>
    </div>
  );
}
